import {
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
} from "@/components/ui/table";
import { formatInTimeZone } from "date-fns-tz";
import { copyToClipboard } from "@/utils/copy-to-clipboard";
import { CopyButton } from "@/components/copy-button";

export const AffectedBookingsTable = ({ data }: any) => {
  return (
    <div className="block w-full bg-white border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      <Table>
        <TableHeader className="h-[52px]">
          <TableRow>
            <TableHead className="px-4 text-zinc-500">ID da reserva</TableHead>
            <TableHead className="px-4 text-zinc-500">
              Data da reserva
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data?.cancelledBookings.map((booking: any) => {
            return (
              <TableRow className="h-[52px]" key={booking.id}>
                <TableCell className="px-4 flex flex-row items-center justify-between">
                  <div>{booking.id}</div>
                  <div>
                    <CopyButton action={() => copyToClipboard(booking.id)} />
                  </div>
                </TableCell>
                <TableCell className="px-4">
                  {formatInTimeZone(booking.bookingDate, "UTC", "dd/MM/yyyy")}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
